import React from "react";
import ProductionShow from "components/ProductionShow/indexVideo";
import ScheduleContainer from "../../../components/ScheduleContainer";
import Slides from "./Slides";
import RuleFooter from "./RuleFooter";

function Rule() {
  return (
    <ScheduleContainer>
      <ProductionShow
        title={["小米一直将", "用户的信息安全和隐私保护", "视为我们的生存之本"]}
        downDesc="了解我们坚持的原则和信守的承诺"
      />
      <Slides />
      <RuleFooter />
    </ScheduleContainer>
  );
}

export default Rule;
